import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const LogOutIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "LogOutIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}

      <path
        d="M16.8271 16.1611C16.6353 16.1611 16.4434 16.0879 16.2969 15.9414C16.0039 15.6484 16.0039 15.1738 16.2969 14.8809L19.1768 12.001L16.2969 9.1211C16.0039 8.82813 16.0039 8.35352 16.2969 8.06055C16.5898 7.76758 17.0645 7.76758 17.3574 8.06055L20.7676 11.4707C21.0606 11.7637 21.0606 12.2383 20.7676 12.5313L17.3574 15.9414C17.2109 16.0879 17.019 16.1611 16.8271 16.1611Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M20.2373 12.751H10.2559C9.8418 12.751 9.50586 12.415 9.50586 12.001C9.50586 11.5869 9.8418 11.251 10.2559 11.251H20.2373C20.6514 11.251 20.9873 11.5869 20.9873 12.001C20.9873 12.415 20.6514 12.751 20.2373 12.751Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M9.43615 22H3.796C3.36328 22 3.01221 21.6489 3.01221 21.2162V2.78379C3.01221 2.35108 3.36328 2 3.796 2H9.43615C9.86887 2 10.2199 2.35108 10.2199 2.78379C10.2199 3.21651 9.86887 3.56759 9.43615 3.56759H4.57979V20.4324H9.43615C9.86887 20.4324 10.2199 20.7835 10.2199 21.2162C10.2199 21.6489 9.86887 22 9.43615 22Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default LogOutIcon;
